import { MessageComposerDialog } from "@/components/ui/message-composer-dialog";
import { useToast } from "@/components/ui/use-toast.ts";
import { useSendLeadMentorMessage } from "@/lib/api/training-simulator/training-simulator";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events.ts";

interface TrainingLeadMentorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  attemptId?: string;
}

export function TrainingLeadMentorModal({
  open,
  onOpenChange,
  attemptId,
}: TrainingLeadMentorModalProps) {
  const { toast } = useToast();
  const { track } = useTrackEvent();
  const { mutateAsync: sendMessage, isPending } =
    useSendLeadMentorMessage(attemptId);

  const handleSend = async (message: string) => {
    try {
      await sendMessage({ message });
      track(PostHogEvents.SIMULATOR_LEAD_MENTOR_MESSAGE_SENT);
      toast({
        title: "Your message has been sent to your lead mentor",
        description: "Check out the support chat to view it.",
      });
    } catch (error) {
      toast({
        title: "Couldn't send message",
        description: "Please try again.",
        variant: "destructive",
      });
      throw error;
    }
  };

  return (
    <MessageComposerDialog
      open={open}
      title="Message Lead Mentor"
      description="Leave feedback for the entire performance or ask for help with this level."
      placeholder="Type your message..."
      isPending={isPending}
      onOpenChange={onOpenChange}
      onSubmit={handleSend}
    />
  );
}
